var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF564F",
    d: "M15.857 10.286h.857l-1.928 4.286h-.857L12 10.286h.857l1.5 3.428zM4.286 14.572V9.429h-.857v5.143zm2.357 0L4.714 12l1.929-2.57h1.071L5.786 12l1.928 2.572zm3.313-4.286c-.943 0-1.676.514-1.727 1.286h.84c.077-.365.565-.429.887-.429c.317 0 .758.15.758.591V12H9.647c-.947 0-1.504.57-1.504 1.294c0 .763.57 1.278 1.414 1.278a1.5 1.5 0 0 0 1.157-.446v.446h.858v-2.906c0-.836-.643-1.38-1.616-1.38m.758 2.361v.257c-.055.558-.428.78-1.011.81c-.339.018-.634-.154-.634-.428s.201-.523.685-.557zm8.238-2.361c-.939 0-1.672.514-1.728 1.286h.845c.077-.365.565-.429.883-.429c.317 0 .762.15.762.591V12h-1.071c-.951 0-1.5.57-1.5 1.294c0 .763.57 1.278 1.41 1.278a1.5 1.5 0 0 0 1.157-.446v.446h.857v-2.906c0-.836-.643-1.38-1.615-1.38m.762 2.361v.257c-.055.558-.428.78-1.011.81c-.343.018-.634-.154-.634-.428s.201-.523.685-.557z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/kava.3906640d4ae1a7794c0da83b11cf6db0.svg";
export { ForwardRef as ReactComponent };